import React, { useState, useEffect } from 'react';
import { getEnquiryData } from '../../services/getAllApi';
import '../../styles/StudentTable.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import { addRemarkToEnquiry, deleteEnquiry } from '../../services/getAdminApi';
import { Delete } from '@mui/icons-material';

const StudentTable = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [remarks, setRemarks] = useState({});

  useEffect(() => {
    getAllData();
  }, []);

  const getAllData = () => {
    getEnquiryData()
      .then(response => {
        const enquiries = response.data.enquiries.map((enquiry) => {
          const formattedDate = new Date(enquiry.created_at).toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
          });
          return {
            ...enquiry,
            created_at: formattedDate,
            originalDate: new Date(enquiry.created_at),
          };
        });
        setData(enquiries);
        setFilteredData(enquiries);
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  };

  const handleDelete = (studentId) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await deleteEnquiry(studentId);
          const updatedList = filteredData.filter((item) => item.id !== studentId);
          setFilteredData(updatedList);
          setData(updatedList);
          Swal.fire('Deleted!', 'The student enquiry has been removed.', 'success');
        } catch (error) {
          Swal.fire('Error!', 'Failed to delete the student enquiry.', 'error');
        }
      }
    });
  };

  const handleRemarkSave = async (id, remark) => {
    console.log("Saving remark:", remark, "for id:", id);
    try {
      const response = await addRemarkToEnquiry(id, remark);  // Assuming addRemarkToEnquiry accepts (id, remark)
      console.log("API response for addRemarkToEnquiry:", response);
      // Update the data in the state
      const updatedList = filteredData.map(item => 
        item.id === id ? { ...item, remark } : item
      );
      setFilteredData(updatedList);
      setData(updatedList);
      toast.success('Remark updated successfully!');
    } catch (error) {
      if (error.response && error.response.data) {
        console.error('Backend error:', error.response.data);
        toast.error(`Failed to update remark: ${error.response.data.message || JSON.stringify(error.response.data)}`);
      } else {
        console.error('Error updating remark:', error);
        toast.error('Failed to update remark.');
      }
    }
  };

  return (
    <div>
      <div className="dashboard-heading-div">
        <p>Student Enquiries</p>
      </div>

      <div className='table-container-registered-students'>
        <table>
          <thead>
            <tr>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Contact Number</th>
              <th>Email Address</th>
              <th>City</th>
              <th>Course Interested</th>
              <th>More Info</th>
              <th>Created At</th>
              <th>Remark</th>
              <th>Add Remark</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((row) => (
              <tr key={row.id}>
                <td>{row.first_name}</td>
                <td>{row.last_name}</td>
                <td>{row.contact_number}</td>
                <td>{row.email_address}</td>
                <td>{row.city}</td>
                <td>{row.course_interested}</td>
                <td>{row.more_info}</td>
                <td>{row.created_at}</td>
                <td>{row.remark}</td>
                <td>
                  <input
                    type="text"
                    placeholder='Enter Remarks Here'
                    className='student-remarks-input'
                    value={remarks[row.id] !== undefined ? remarks[row.id] : row.remark || ''}
                    onChange={(e) => setRemarks({ ...remarks, [row.id]: e.target.value })}
                    onBlur={() => {
                      const updatedRemark = remarks[row.id];
                      if (updatedRemark !== undefined && updatedRemark !== row.remark) {
                        handleRemarkSave(row.id, updatedRemark);
                      }
                    }}
                  />
                </td>
                <td>
                  <button className="delete-btn" onClick={() => handleDelete(row.id)}>
                    <Delete />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <ToastContainer />
    </div>
  );
};

export default StudentTable;
